export type Offer = {
	offer_id: number;
	business_operation_code: string;
	payment_journey_url: string;
	is_standard: boolean;
	public: boolean;
	label: string;
	operator_id: number;
	product_id: number;
	channel: string;
	date_start: null | string;
	date_end: null | string;
	subscription_period_collection: SubscriptionPeriodCollection;
};

export type SubscriptionPeriodCollection = {
	try_and_buy?: SubscriptionPeriod;
	initial?: SubscriptionPeriod;
	renewal: SubscriptionPeriod;
};

export type SubscriptionPeriod = {
	period: string;
	duration: number;
	duration_type: 'D' | 'M' | 'Y'; // Assuming "M" for months, "Y" for years
	iteration?: number;
	price?: string;
	price_total?: string;
	price_by_month?: string;
	reference?: string;
};

export enum OfferId {
	Premium = 1,
	PremiumWithHifi = 1000001,
	DuoWithHifi = 1000002,
	Family = 100001,
	FamilyWithHifi = 1000006,
}
